<template>
  <page-section>
    <rest-list :payload="fetchEndpoint">
      <rest-list-column
        prop="id"
        :title="$t('AuditLog_LiveActivities_Column_Id')"
        :sortable="false"
        :min-width="200"
      />
      <rest-list-column
        prop="activity_id"
        :title="$t('AuditLog_LiveActivities_Column_ActivityId')"
        :sortable="false"
        :min-width="200"
      />
      <rest-list-column
        prop="activity_type"
        :title="$t('AuditLog_LiveActivities_Column_ActivityType')"
        :sortable="false"
        :min-width="200"
      />
      <rest-list-column
        prop="event_type"
        :title="$t('AuditLog_LiveActivities_Column_EventType')"
        :sortable="false"
        :min-width="200"
      />
      <rest-list-column
        prop="status"
        :title="$t('AuditLog_LiveActivities_Column_Status')"
        :sortable="false"
        :min-width="200"
      />
      <rest-list-column
        prop="latest_outcome"
        :title="$t('AuditLog_LiveActivities_Column_LatestOutcome')"
        :sortable="false"
        :min-width="200"
      />
      <rest-list-column
        prop="total_batches"
        :title="$t('AuditLog_LiveActivities_Column_TotalBatches')"
        :sortable="false"
        :min-width="200"
      />
      <rest-list-column
        prop="batches_processed"
        :title="$t('AuditLog_LiveActivities_Column_BatchesProcessed')"
        :sortable="false"
        :min-width="200"
      />
      <rest-list-column
        prop="total_user_ids"
        :title="$t('AuditLog_LiveActivities_Column_TotalUserIds')"
        :sortable="false"
        :min-width="200"
      />
      <rest-list-column
        prop="total_tokens_matched"
        :title="$t('AuditLog_LiveActivities_Column_TotalTokensMatched')"
        :sortable="false"
        :min-width="200"
      />
      <rest-list-column
        prop="successful_tokens"
        :title="$t('AuditLog_LiveActivities_Column_SuccessfulTokens')"
        :sortable="false"
        :min-width="200"
      />
      <rest-list-column
        prop="failed_tokens"
        :title="$t('AuditLog_LiveActivities_Column_FailedTokens')"
        :sortable="false"
        :min-width="200"
      />
      <rest-list-column
        prop="created_at"
        :is-range="true"
        :filter-date-range="true"
        :filter-date="false"
        :title="$t('AuditLog_LiveActivities_Column_CreatedAt')"
        :sortable="false"
        :date-picker-props="datePickerProps"
        :min-width="200"
      />
      <rest-list-column
        :is-range="true"
        :filter-date-range="true"
        :filter-date="false"
        prop="updated_at"
        :title="$t('AuditLog_LiveActivities_Column_UpdatedAt')"
        :sortable="false"
        :date-picker-props="datePickerProps"
        :min-width="200"
      />
      <rest-list-column
        prop="activity_attributes"
        :title="$t('AuditLog_LiveActivities_Column_ActivityAttributes')"
        :sortable="false"
        :filterable="false"
        :min-width="200"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="
              showDataPopup(
                'Data',
                JSON.stringify(scope.row.activity_attributes)
              )
            "
            v-if="scope.row.activity_attributes"
          >
            {{ $t('AuditLog_LiveActivities_Column_ViewBtn') }}
            <el-icon name="view" />
          </el-button>
          <span v-else>-</span>
        </template>
      </rest-list-column>
      <rest-list-column
        prop="content_state"
        :title="$t('AuditLog_LiveActivities_Column_ContentState')"
        :sortable="false"
        :filterable="false"
        :min-width="200"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="
              showDataPopup('Data', JSON.stringify(scope.row.content_state))
            "
            v-if="scope.row.content_state"
          >
            {{ $t('AuditLog_LiveActivities_Column_ViewBtn') }}
            <el-icon name="view" />
          </el-button>
          <span v-else>-</span>
        </template>
      </rest-list-column>
    </rest-list>
    <el-dialog
      :title="dataPopup"
      :visible="dataPopup"
      :modal="false"
      :modal-append-to-body="false"
      :before-close="closeDataPopup"
    >
      <vue-json-pretty :data="jsonData" class="json-wrapper" />
    </el-dialog>
  </page-section>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import { projectEndpoint } from '@/core/helpers'
import RestListColumn from '@/common/components/rest/RestListColumn'
import PageSection from '@/common/components/page/PageSection'
import VueJsonPretty from 'vue-json-pretty'

export default {
  name: 'LiveActivityAuditLog',
  components: { PageSection, RestListColumn, RestList, VueJsonPretty },
  data() {
    return {
      dataPopup: null,
      jsonData: null
    }
  },
  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `live-activity/audit-log`
      })
    },
    datePickerProps() {
      return {
        type: 'daterange',
        value_format: 'yyyy-MM-dd'
      }
    }
  },
  methods: {
    showDataPopup(title, json) {
      this.jsonData = JSON.parse(json)
      this.dataPopup = title
    },
    closeDataPopup() {
      this.dataPopup = false
      this.jsonData = null
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/audit-log/pages/LiveActivityAuditLog.vue